<template>
  <Backdrop v-show="showBackdrop" @click="changeMobileMenuVisibility">
    <transition name="navigation-bar-slider">
      <div class="navigation-bar" v-show="showMobileMenu">
        <NavigationItems />
      </div>
    </transition>
  </Backdrop>
</template>
<script>
import { mapMutations } from "vuex";
import Backdrop from "../../../UI/Backdrop";
import NavigationItems from "./NavigationItems";

export default {
  components: {
    NavigationItems,
    Backdrop
  },
  methods: {
    ...mapMutations(["changeMobileMenuVisibility"])
  },
  computed: {
    showMobileMenu() {
      return this.$store.getters.showMobileMenu;
    },
    showBackdrop() {
      return this.$store.getters.showBackdrop;
    }
  }
};
</script>
<style lang="scss" scoped>
.navigation-bar {
  position: fixed;
  top: 0;
  background-color: #fff;
  width: 20rem;
  height: 100%;
  z-index: 600;
  padding-top: 5rem;
}
.navigation-bar-slider-enter-active {
  animation: slide-in 0.3s ease-out forwards;
}
.navigation-bar-slider-leave-active {
  animation: slide-out 0.3s ease-out forwards;
}
@keyframes slide-in {
  from {
    transform: translateX(-25rem);
    display: none;
  }
  to {
    transform: translateX(0);
    display: block;
  }
}
@keyframes slide-out {
  from {
    transform: translateX(0);
    display: block;
  }
  to {
    transform: translateX(-25rem);
    display: none;
  }
}
</style>
